var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectWok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.877,
    height: 251.341,
    viewBox: "0 0 319.877 251.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .selectwok-cls-1 {\r\n        fill: #5d94fd;\r\n      }\r\n\r\n      .selectwok-cls-2 {\r\n        fill: none;\r\n        stroke: #5d94fd;\r\n        stroke-width: 3px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6996",
    "data-name": "Group 6996",
    transform: "translate(616.207 -198.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    className: "selectwok-cls-1",
    d: "M-351.847,574.594l.236,0C-353.644,574.592-355.214,574.592-351.847,574.594Z",
    transform: "translate(-102.016 -174.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    className: "selectwok-cls-1",
    d: "M-347.236,574.591h0Z",
    transform: "translate(-105.54 -174.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    className: "selectwok-cls-1",
    d: "M-354.367,364.872c4.513.025,9.026.007,13.54.007q3.332,0,6.665.005-3.333,0-6.665-.005C-345.341,364.879-349.854,364.9-354.367,364.872Z",
    transform: "translate(-101.69 -52.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    className: "selectwok-cls-1",
    d: "M-396.2,239.062a22.943,22.943,0,0,0-16.986-11.815,5.2,5.2,0,0,1-.949-.359H-562.6c-.794.2-1.591.393-2.383.606-10.232,2.754-16.461,9.271-18.526,19.707a6.063,6.063,0,0,1-.36.956V407.466c3.505,8.554,6.334,10.426,15.758,10.426q24.912,0,49.823,0a13.308,13.308,0,0,0,2.284-.1,4.04,4.04,0,0,0,3.5-4.038,4.009,4.009,0,0,0-3.452-4.072,14.084,14.084,0,0,0-2.491-.119q-25.641-.009-51.282-.005c-4.5,0-5.8-1.324-5.8-5.881q0-75.568,0-151.137c0-10.684,6.609-17.3,17.281-17.3q60.247-.008,120.493,0h2.279a8.966,8.966,0,0,1-.536.946c-4.05,5.091-5.266,10.986-5.259,17.355q.053,47.5.028,95.006a36.48,36.48,0,0,1,3.867.261,62.208,62.208,0,0,1,4.472-15.682V316.69c0-.635,0-17.262.039-17.56s.1-.607.176-.927h24.061c9.43,0,12.253-1.867,15.76-10.426V248.158C-393.956,245.112-394.656,241.851-396.2,239.062Zm-5.015,45.788c-.005,3.057-1.442,4.928-4.161,4.957-9.089.1-18.18.037-27.525.037,0-8.89,0-17.5,0-26.108,0-4.239-.088-8.48.031-12.715a15.766,15.766,0,0,1,10.934-14.943,15.64,15.64,0,0,1,17.607,5.671,15.775,15.775,0,0,1,3.112,9.747Q-401.185,268.173-401.219,284.85Z",
    transform: "translate(32.103 28.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    className: "selectwok-cls-1",
    d: "M-411.951,469.938c.42,2.126,2.177,3.277,5.106,3.278q22.815.011,45.631,0a10.846,10.846,0,0,0,1.249-.035,4.117,4.117,0,0,0,3.926-4.089,4.1,4.1,0,0,0-3.838-4.166,15.074,15.074,0,0,0-1.873-.047q-11.147,0-22.295,0c-7.709,0-15.419-.022-23.128.01C-410.549,464.9-412.523,467.044-411.951,469.938Z",
    transform: "translate(-68.064 -110.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    className: "selectwok-cls-1",
    d: "M-348.215,574.591h0Z",
    transform: "translate(-105.089 -174.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    className: "selectwok-cls-1",
    d: "M-383.926,574.63a7.386,7.386,0,0,0-.786-.048h-.851l-.236,0c-3.368,0-1.8,0,.236,0h.027c-7.213,0-14.425-.019-21.638.011-3.376.014-5.351,2.154-4.778,5.048.42,2.125,2.177,3.277,5.106,3.278,15.21.008,6.371,0,21.582,0a10.772,10.772,0,0,0,1.249-.035,4.118,4.118,0,0,0,3.926-4.09A4.1,4.1,0,0,0-383.926,574.63Z",
    transform: "translate(-68.064 -174.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    className: "selectwok-cls-1",
    d: "M-347.66,574.588c-.27,0-.541,0-.812,0h.812Z",
    transform: "translate(-105.127 -174.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    className: "selectwok-cls-1",
    d: "M-345.847,574.592c3.609,0,1.547,0-.679,0h.679Z",
    transform: "translate(-106.261 -174.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    className: "selectwok-cls-1",
    d: "M-377.228,464.88q11.147,0,22.295,0-11.147,0-22.295,0c-7.709,0-15.419-.022-23.128.01C-392.647,464.858-384.937,464.88-377.228,464.88Z",
    transform: "translate(-74.881 -110.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    className: "selectwok-cls-1",
    d: "M-347.776,353.217q3.332,0,6.665.005t6.666-.01c3.249-.014,5.109-1.577,5.084-4.209-.024-2.556-1.85-4.112-4.964-4.119q-13.539-.031-27.079,0c-3.068.008-4.911,1.645-4.883,4.205s1.859,4.1,4.971,4.12C-356.8,353.236-352.29,353.217-347.776,353.217Z",
    transform: "translate(-94.742 -40.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    className: "selectwok-cls-1",
    d: "M-407.951,353.246a4.234,4.234,0,0,0,4.149-4.109,4.228,4.228,0,0,0-4.082-4.172,4.167,4.167,0,0,0-4.119,4.1A4.167,4.167,0,0,0-407.951,353.246Z",
    transform: "translate(-68.091 -40.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    className: "selectwok-cls-1",
    d: "M-384.576,664.967a4.292,4.292,0,0,0-4.215,4.056,4.294,4.294,0,0,0,4.056,4.217,4.294,4.294,0,0,0,4.215-4.058A4.288,4.288,0,0,0-384.576,664.967Z",
    transform: "translate(-81.622 -227.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    className: "selectwok-cls-1",
    d: "M-514.323,278.112A18.7,18.7,0,0,0-533,296.786a18.7,18.7,0,0,0,18.674,18.673,18.7,18.7,0,0,0,18.673-18.673A18.7,18.7,0,0,0-514.323,278.112Zm0,33.8a15.129,15.129,0,0,1-15.129-15.128,15.129,15.129,0,0,1,15.129-15.129,15.129,15.129,0,0,1,15.129,15.129A15.129,15.129,0,0,1-514.323,311.914Z",
    transform: "translate(2.444 -1.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    className: "selectwok-cls-1",
    d: "M-509.368,286.612A15.129,15.129,0,0,0-524.5,301.741a15.129,15.129,0,0,0,15.129,15.128,15.129,15.129,0,0,0,15.129-15.128A15.129,15.129,0,0,0-509.368,286.612Zm0,26.712a11.6,11.6,0,0,1-11.584-11.584,11.6,11.6,0,0,1,11.584-11.584,11.6,11.6,0,0,1,11.584,11.584A11.6,11.6,0,0,1-509.368,313.324Z",
    transform: "translate(-2.511 -6.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    className: "selectwok-cls-1",
    d: "M-514.323,397.992A18.7,18.7,0,0,0-533,416.666a18.7,18.7,0,0,0,18.674,18.673,18.7,18.7,0,0,0,18.673-18.673A18.7,18.7,0,0,0-514.323,397.992Zm0,33.8a15.129,15.129,0,0,1-15.129-15.128,15.129,15.129,0,0,1,15.129-15.129,15.129,15.129,0,0,1,15.129,15.129A15.129,15.129,0,0,1-514.323,431.794Z",
    transform: "translate(2.444 -71.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    className: "selectwok-cls-1",
    d: "M-509.368,406.492A15.129,15.129,0,0,0-524.5,421.621a15.129,15.129,0,0,0,15.129,15.128,15.129,15.129,0,0,0,15.129-15.128A15.129,15.129,0,0,0-509.368,406.492Zm0,26.712a11.6,11.6,0,0,1-11.584-11.584,11.6,11.6,0,0,1,11.584-11.584,11.6,11.6,0,0,1,11.584,11.584A11.6,11.6,0,0,1-509.368,433.2Z",
    transform: "translate(-2.511 -76.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    className: "selectwok-cls-1",
    d: "M-514.323,518.112A18.7,18.7,0,0,0-533,536.785a18.7,18.7,0,0,0,18.674,18.674,18.7,18.7,0,0,0,18.673-18.674A18.7,18.7,0,0,0-514.323,518.112Zm0,33.8a15.129,15.129,0,0,1-15.129-15.129,15.129,15.129,0,0,1,15.129-15.128,15.129,15.129,0,0,1,15.129,15.128A15.129,15.129,0,0,1-514.323,551.914Z",
    transform: "translate(2.444 -141.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    className: "selectwok-cls-1",
    d: "M-509.368,526.612A15.129,15.129,0,0,0-524.5,541.74a15.129,15.129,0,0,0,15.129,15.129,15.129,15.129,0,0,0,15.129-15.129A15.129,15.129,0,0,0-509.368,526.612Zm0,26.713a11.6,11.6,0,0,1-11.584-11.584,11.6,11.6,0,0,1,11.584-11.583,11.6,11.6,0,0,1,11.584,11.583A11.6,11.6,0,0,1-509.368,553.325Z",
    transform: "translate(-2.511 -146.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    className: "selectwok-cls-1",
    d: "M-273.372,460.345c7.857,0,14.226,18.187,14.226,40.621a101.047,101.047,0,0,1-2.333,22.291,32.908,32.908,0,0,1-32.628,28.665,32.758,32.758,0,0,1-16.1-4.2,32.9,32.9,0,0,1-16.808-28.708,32.909,32.909,0,0,1,32.91-32.909c.178,0,.356,0,.534.007q0-1.772,0-3.544c-.178,0-.356-.008-.534-.008a36.5,36.5,0,0,0-36.454,36.454,36.529,36.529,0,0,0,18.616,31.8,36.476,36.476,0,0,0,17.839,4.656,36.513,36.513,0,0,0,36.12-31.581,105.032,105.032,0,0,0,2.385-22.919c0-21.947-6.1-44.165-17.771-44.165-4.7,0-8.785,3.68-11.862,10.345q0,5.7,0,11.394C-282.687,467.575-278.326,460.345-273.372,460.345Z",
    transform: "translate(-115.568 -105.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    className: "selectwok-cls-1",
    d: "M-241.868,497.027q0,1.772,0,3.544a33.024,33.024,0,0,1,6.844.833c.384-2.982.888-5.8,1.494-8.4q0-5.7,0-11.394A62.207,62.207,0,0,0-238,497.287,36.511,36.511,0,0,0-241.868,497.027Z",
    transform: "translate(-167.273 -120.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    className: "selectwok-cls-1",
    d: "M-322.061,523.967a32.9,32.9,0,0,0,16.808,28.708,32.756,32.756,0,0,0,16.1,4.2,32.908,32.908,0,0,0,32.628-28.665,101.049,101.049,0,0,0,2.333-22.291c0-22.434-6.369-40.621-14.226-40.621-4.954,0-9.315,7.231-11.862,18.194q0,6.192,0,12.383l1.523.349.5-3.875c2.066-16.035,7.093-23.506,9.84-23.506,3.625,0,10.682,13.087,10.682,37.076a97.635,97.635,0,0,1-2.242,21.5l-.061.343a29.406,29.406,0,0,1-29.112,25.573,29.372,29.372,0,0,1-14.365-3.746,29.431,29.431,0,0,1-15-25.618A29.4,29.4,0,0,1-289.151,494.6c.178,0,.356.012.533.015q0-1.776,0-3.552c-.178,0-.355-.007-.534-.007A32.91,32.91,0,0,0-322.061,523.967Z",
    transform: "translate(-120.524 -110.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    className: "selectwok-cls-1",
    d: "M-235.816,520.787l2.285.524q0-6.192,0-12.384c-.605,2.607-1.11,5.422-1.494,8.4a33.048,33.048,0,0,0-6.844-.833q0,1.777,0,3.552A29.571,29.571,0,0,1-235.816,520.787Z",
    transform: "translate(-167.273 -136.123)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6997",
    "data-name": "Group 6997",
    transform: "translate(-616.207 198.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_9",
    "data-name": "Polygon 9",
    className: "selectwok-cls-1",
    d: "M19,0,38,24H0Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    className: "selectwok-cls-2",
    y2: 149.464,
    transform: "translate(18.932 22.918)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6998",
    "data-name": "Group 6998",
    transform: "translate(-334.194 198.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_9-2",
    "data-name": "Polygon 9",
    className: "selectwok-cls-1",
    d: "M18.932,0,37.864,23.914H0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128-2",
    "data-name": "Line 128",
    className: "selectwok-cls-2",
    y2: 149.464,
    transform: "translate(18.932 22.918)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectWok);
export default __webpack_public_path__ + "static/media/SelectWok.svg";
export { ForwardRef as ReactComponent };